import { render, staticRenderFns } from "./trophy.vue?vue&type=template&id=7d07456a&"
import script from "./trophy.vue?vue&type=script&lang=js&"
export * from "./trophy.vue?vue&type=script&lang=js&"
import style0 from "./trophy.vue?vue&type=style&index=0&id=7d07456a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports